import { Injectable, inject, TemplateRef } from '@angular/core';
import { Overlay, OverlayRef, OverlayConfig } from '@angular/cdk/overlay';
import { ComponentPortal } from '@angular/cdk/portal';
import { SidePanelComponent, SidePanelConfig } from './side-panel.component';
import { Subject } from 'rxjs';
import { EventLogReferrerConstants } from '../../../core/constants/event-log-referrer.constants';

@Injectable({
  providedIn: 'root'
})
export class SidePanelService {
  private overlay = inject(Overlay);
  private overlayRef: OverlayRef | null = null;
  private panelComponent: SidePanelComponent | null = null;


  private closeSubject = new Subject<void>();
  public onClose$ = this.closeSubject.asObservable();

  private reloadSubject = new Subject<void>();
  public reloadEvents$ = this.reloadSubject.asObservable();

  private wasSubmittedSuccessfully = false;

  open(config?: SidePanelConfig): SidePanelComponent {
    if (this.overlayRef) {
      this.close();
    }

    const overlayConfig: OverlayConfig = {
      hasBackdrop: true,
      backdropClass: 'side-panel-backdrop',
      positionStrategy: this.overlay.position()
        .global()
        .right('0')
        .top('0')
        .bottom('0'),
      panelClass: 'side-panel-overlay',
      scrollStrategy: this.overlay.scrollStrategies.block()
    };

    this.overlayRef = this.overlay.create(overlayConfig);

    const portal = new ComponentPortal(SidePanelComponent);
    const componentRef = this.overlayRef.attach(portal);
    this.panelComponent = componentRef.instance;

    if (config) {
      if (config.formType !== undefined) {
        this.panelComponent.formType = config.formType;
      }
      if (config.title !== undefined) {
        this.panelComponent.title = config.title;
      }
      if (config.contentTemplate !== undefined) {
        this.panelComponent.contentTemplate = config.contentTemplate;
      }
      if(config.referrer) {
        this.panelComponent.referrer = config.referrer;
      }
    }

    document.body.style.overflow = 'hidden';

    this.panelComponent.closeEvent.subscribe(() => {
      this.close();
    });

    this.panelComponent.reloadEvents.subscribe(() => {
      this.wasSubmittedSuccessfully = true;
    });

    return this.panelComponent;
  }

  close(): void {
    if (this.overlayRef) {
      const shouldReload = this.wasSubmittedSuccessfully &&
        this.panelComponent?.referrer === EventLogReferrerConstants.EVENT_PAGE;

      this.overlayRef.detach();
      this.overlayRef.dispose();
      this.overlayRef = null;
      this.panelComponent = null;
      this.wasSubmittedSuccessfully = false;

      document.body.style.overflow = '';

      this.closeSubject.next();

      if (shouldReload) {
        this.reloadSubject.next();
      }
    }
  }

  isOpen(): boolean {
    return this.overlayRef !== null && this.overlayRef.hasAttached();
  }
}
